import moment from 'moment';

moment.updateLocale('da', {
  calendar: {
    lastDay: '[I går kl.] HH:mm',
    sameDay: '[I dag kl.] HH:mm',
    nextDay: '[I morgen kl.] HH:mm',
    lastWeek: '[Sidste] dddd [kl.] HH:mm',
    nextWeek: 'dddd [kl.] HH:mm',
    sameElse: 'L',
  },
  weekdays: 'mandag_tirsdag_onsdag_torsdag_fredag_lørdag_søndag'.split('_'),
  months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
    '_'
  ),
});

const languageCode = localStorage.getItem('i18nextLng');
moment.locale(languageCode || 'da');
